import { getAccessToken } from "./fetchFunctions";

/**
 * @description Decodes JWT token and returns payload.
 * @param {string} token - JWT token string
 * @returns {Object|null} Decoded token payload or null if invalid
 */
export const decodeJWT = (token) => {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
};

/**
 * @description Extracts user role from current access token.
 * @returns {string|null} User role ('admin' or 'user') or null if not authenticated
 */
export const getUserRole = () => {
  const token = getAccessToken();
  if (!token) return null;
  const decoded = decodeJWT(token);
  return decoded?.role || null;
};
